import EmptyResults from 'components/EmptyResults'
import GridSpinner from 'components/UI/GridSpinner'
import ShowMoreButton from 'components/ShowMoreButton'
import { Button, Icon, List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useTableConfig } from 'modules/Advertisers/List/subcomponents/Table/hooks/useTableConfig'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import { SET_STATUS } from 'modules/Advertisers/List/types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const Table = ({ data = [], pagination, loading, onChangePage }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const pathGen = useGeneratePathI18n()
  const breakpoint = useBreakpoint()

  const changeStatus = useCallback(
    (id, status) => dispatch({ type: SET_STATUS, payload: { id, status } }),
    [],
  )

  const { tableState, tableConfig } = useTableConfig({ changeStatus }, data)

  return data.length === 0 && loading ? (
    <GridSpinner />
  ) : (
    <>
      <List
        table={tableState}
        config={tableConfig}
        EmptyComponent={() => (
          <EmptyResults
            header={t('advertisers::empty_list_heading')}
            text={t('advertisers::empty_list')}
            icon={<Icon name={'users'} />}
            actionButton={
              <Button
                variant={'primary'}
                size={'l'}
                component={Link}
                fullWidth={!breakpoint.fb}
                to={pathGen(ROUTES.ADVERTISER_NEW)}
                startIcon={<Icon name={'plus'} />}
              >
                {t('advertisers::buttons.add')}
              </Button>
            }
          />
        )}
      />
      <ShowMoreButton
        onClick={() => onChangePage(1)}
        loading={loading}
        current={data.length}
        total={pagination.total}
      />
    </>
  )
}

Table.propTypes = {
  data: PropTypes.array,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  onChangePage: PropTypes.func,
  i18n: PropTypes.string,
}

export default Table
